const samePlace = (review, place) => Number(review?.placeid ?? review?.placeId) === Number(place?.id);

export const adminPlaceReviews = (place, reviews = []) => (Array.isArray(reviews) ? reviews : [])
  .filter(review => samePlace(review, place) && !review?.metadata?.rejected)
  .sort((a, b) => {
    const aTime = Date.parse(a?.created_at || a?.createdAt || 0) || 0;
    const bTime = Date.parse(b?.created_at || b?.createdAt || 0) || 0;
    return bTime - aTime;
  });

export const resolveAdminBackLayer = ({ adminImageViewer, adminPreview, showAdmin } = {}) => {
  if (adminImageViewer) return "image";
  if (adminPreview) return "preview";
  if (showAdmin) return "panel";
  return null;
};
